<div class="container-fluid fl-wrapper">
	<div class="d-flex justify-content-between align-items-center">
        <h3>Funding List MOM</h3>
        <form [formGroup]="inputDateForm" class="mt-4">
			<div class="container-fluid">
				<div class="row g-3"  style="position: relative; top: 75px;">
					<div class="col-12 col-lg-6 col-xl-3">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Choose a date</mat-label>
							<input matInput [matDatepicker]="picker" formControlName="input_date">
							<mat-hint>MM/YYYY</mat-hint>
							<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
							<mat-datepicker #picker startView="multi-year" (monthSelected)="setMonthAndYear($event, picker)" panelClass="month-picker" ></mat-datepicker>
						</mat-form-field>
					</div>
					<div class="col-12 col-lg-6 col-xl-3">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Target</mat-label>
							<input type="number" step=".01" matInput formControlName="target" />
						</mat-form-field>
					</div>
					<div class="col-12 col-lg-6 col-xl-3">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Num of Business Day</mat-label>
							<input type="number" matInput formControlName="num_business_day" />
						</mat-form-field>
					</div>
					<div class="col-12 col-lg-6 col-xl-3">
						<button mat-raised-button color="primary" [disabled]="inputDateForm.invalid" (click)="saveProjection()">Save</button>
					</div>
				</div>
			</div>
		</form>
    </div>
	
	<div style="height: calc(100% - 200px)">
		<app-custom-table
			[columnDefs]="columnDefs"
			[rowData]="loanAccountData"
			[showLoader]="showLoader"
			[showToolPanel]="true"
			[sideBar]="sideBar"
			[pagination]="true"
			[paginationPageSize]="50"
			(cellValueChanged)="onCellValueChanged($event)"
		></app-custom-table>
	</div>
</div>